import { render, staticRenderFns } from "./TestLayoutView.vue?vue&type=template&id=66009b5d&"
import script from "./TestLayoutView.vue?vue&type=script&lang=js&"
export * from "./TestLayoutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports